// Injectable export gate. The library stays fully functional standalone
// (gate unset = allow); the Chartoon app registers a gate that consumes a
// server-side export slot before any encode work. Injection (not an import)
// keeps the packages/* → excalidraw-app dependency rule intact.

export type ExportGateVerdict = { allowed: boolean; message?: string };
export type ExportGate = (format: string) => Promise<ExportGateVerdict>;

let gate: ExportGate | null = null;

export const registerExportGate = (fn: ExportGate | null) => {
  gate = fn;
};

/** Resolves when the export may proceed; throws the gate's message when not. */
export const checkExportGate = async (format: string): Promise<void> => {
  if (!gate) {
    return;
  }
  const verdict = await gate(format);
  if (!verdict.allowed) {
    throw new Error(verdict.message ?? "Export is not available on your plan.");
  }
};
